import React, { useState, useEffect } from 'react';
import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import Chart, { useChart } from '../../chart';
import { catalogs } from '../../../utils/catalogs';
import { grey } from '@mui/material/colors';

const QuestionarySymptomChart = ({
    title,
    first_time_data,
    follow_up_data,
}) => {

    return ( 
        <Box>
            <Typography variant='h5' gutterBottom>
                {title}
            </Typography>
            <Card sx={{p:2, border:`1px solid ${grey[300]}`}}>
                <Box>
                    <Grid container alignItems='center' justifyContent='center'>
                        <Grid item xs={12} md={6}>
                            {first_time_data && <ChartData title="Colaboradores de primera vez" data={first_time_data} />}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {follow_up_data && <ChartData title="Colaboradores de seguimiento" data={follow_up_data} />}
                        </Grid>
                    </Grid>
                </Box>
            </Card>
        </Box>
     );
}
 
export default QuestionarySymptomChart;


const ChartData = ({title, data}) => {

    const chartOptions = useChart({
        labels: data?.labels??[],
        legend: {
            position:'bottom'
        },
        colors:data?.colors??[]
    })

    return(
        <Box>
            <Typography variant='h6' align='center'>
                {title}
            </Typography>
            <Typography variant='body2' align='center'>
                Data de {data.users_count} colabaradores
            </Typography>
            <Box
                sx={{
                    width:'100%',
                    maxWidth:500,
                    margin:'auto'
                }}
                
            >
                <Chart
                    type="pie" 
                    series={data.data} 
                    options={chartOptions}
                />
            </Box>
            
        </Box>
    )
}

/*[
    "3",
    "0",
    "1",
    0
]*/